import store from '../store';
import _ from 'lodash';
import config from '../config';

export class ExperimentImpressionSrv {
  constructor() {}

  addExperimentImpression(experimentId) {
    if (isNaN(experimentId) || experimentId <= 0) {
      return;
    }

    var impressionsKey = this.impressionKey(config);
    var impressions = [];
    if (store.exists(impressionsKey)) {
      impressions = JSON.parse(store.get(impressionsKey));
      if (!_.isArray(impressions)) {
        impressions = [];
      }
    }

    impressions = impressions.filter(imp => {
      return experimentId !== imp;
    });

    impressions.unshift(experimentId);

    if (impressions.length > 50) {
      impressions.pop();
    }
    store.set(impressionsKey, JSON.stringify(impressions));
  }

  getExperimentOpened() {
    var impressions = store.get(this.impressionKey(config)) || '[]';

    impressions = JSON.parse(impressions);

    impressions = _.filter(impressions, el => {
      return _.isNumber(el);
    });

    return impressions;
  }

  impressionKey(config) {
    return 'experiment_impressions-' + config.bootData.user.orgId;
  }
}

const experimentImpressionSrv = new ExperimentImpressionSrv();
export default experimentImpressionSrv;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./public/app/core/services/experiments_impression_srv.ts